import {
  ExternalCalendarEvent,
  ExternalCalendarEventPreview,
} from '@griply/types';

// Omitted keys are left out, not defaulted — an invented `guestCount: 0` would hide a real guest row.
export const getExternalCalendarEventPreview = ({
  location,
  busy,
  videoCallUrl,
  videoCallProvider,
  hasDescription,
  guestCount,
  isOrganizer,
  isRecurring,
  selfResponseStatus,
}: ExternalCalendarEvent): ExternalCalendarEventPreview => ({
  ...(location !== undefined && { location }),
  ...(busy !== undefined && { busy }),
  ...(videoCallUrl !== undefined && { videoCallUrl }),
  ...(videoCallProvider !== undefined && { videoCallProvider }),
  ...(hasDescription !== undefined && { hasDescription }),
  ...(guestCount !== undefined && { guestCount }),
  ...(isOrganizer !== undefined && { isOrganizer }),
  ...(isRecurring !== undefined && { isRecurring }),
  // `null` is carried, not dropped — it is the "nothing to answer" answer
  ...(selfResponseStatus !== undefined && { selfResponseStatus }),
});
